// Imports: local files.
import {
  GET_MANUFACTURERS_START,
  GET_MANUFACTURERS_SUCCESS,
  GET_MANUFACTURERS_FAILED,
  GET_MANUFACTURERS_RESET,
  GET_MANUFACTURER_START,
  GET_MANUFACTURER_SUCCESS,
  GET_MANUFACTURER_FAILED,
  GET_MANUFACTURER_RESET,
  CREATE_MANUFACTURER_START,
  CREATE_MANUFACTURER_SUCCESS,
  CREATE_MANUFACTURER_FAILED,
  CREATE_MANUFACTURER_RESET,
  UPDATE_MANUFACTURER_START,
  UPDATE_MANUFACTURER_SUCCESS,
  UPDATE_MANUFACTURER_FAILED,
  UPDATE_MANUFACTURER_RESET,
  DELETE_MANUFACTURER_START,
  DELETE_MANUFACTURER_SUCCESS,
  DELETE_MANUFACTURER_FAILED,
  DELETE_MANUFACTURER_RESET,
} from '../actions';

const initialLoadingState = {
  loading: false,
  success: false,
  data: null,
  error: false,
  errorMessage: null,
};
const initialState = {
  getAll: initialLoadingState,
  getOne: initialLoadingState,
  create: initialLoadingState,
  updateOne: initialLoadingState,
  deleteOne: initialLoadingState,
};

const manufacturersReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * =======================================================================
     * Get All Manufacturers
     * =======================================================================
     */
    case GET_MANUFACTURERS_START:
      return { ...state, getAll: { ...action.payload } };
    case GET_MANUFACTURERS_SUCCESS:
      return { ...state, getAll: { ...action.payload } };
    case GET_MANUFACTURERS_FAILED:
      return { ...state, getAll: { ...action.payload } };
    case GET_MANUFACTURERS_RESET:
      return { ...state, getAll: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Get One Manufacturer
     * =======================================================================
     */
    case GET_MANUFACTURER_START:
      return { ...state, getOne: { ...action.payload } };
    case GET_MANUFACTURER_SUCCESS:
      return { ...state, getOne: { ...action.payload } };
    case GET_MANUFACTURER_FAILED:
      return { ...state, getOne: { ...action.payload } };
    case GET_MANUFACTURER_RESET:
      return { ...state, getOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Create Manufacturer
     * =======================================================================
     */
    case CREATE_MANUFACTURER_START:
      return { ...state, create: { ...action.payload } };
    case CREATE_MANUFACTURER_SUCCESS:
      return { ...state, create: { ...action.payload } };
    case CREATE_MANUFACTURER_FAILED:
      return { ...state, create: { ...action.payload } };
    case CREATE_MANUFACTURER_RESET:
      return { ...state, create: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Update One Manufacturer
     * =======================================================================
     */
    case UPDATE_MANUFACTURER_START:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_MANUFACTURER_SUCCESS:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_MANUFACTURER_FAILED:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_MANUFACTURER_RESET:
      return { ...state, updateOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Delete One Manufacturer
     * =======================================================================
     */
    case DELETE_MANUFACTURER_START:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_MANUFACTURER_SUCCESS:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_MANUFACTURER_FAILED:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_MANUFACTURER_RESET:
      return { ...state, deleteOne: { ...initialLoadingState } };
    default:
      return state;
  }
};

export default manufacturersReducer;
